import React, { createContext, useContext, useEffect, useState } from "react";
import { FormFiltersInterface } from "../features/contabilidad/validadorAsientos/interfaces/FormFiltersInterface";
import { TotalesMovimientosContables } from "../features/contabilidad/validadorAsientos/interfaces/TotalesMovimientosContablesInterface";
import { RespuestaRegistrosEnviados } from "../features/contabilidad/validadorAsientos/models/respuestaRegistrosEnviadosDto";
import { obtenerTotalesMovimientosContables } from "../features/contabilidad/validadorAsientos/services/serviceValidadorAsientosContables";
import { useLoader } from "../hooks/useLoader";
import { useLocation } from "react-router-dom";

interface AsientosContablesContextType {
  reloadFlag: number;
  incrementReloadFlag: () => void;
  formFilters: FormFiltersInterface | null;
  setFormFilters: (filters: FormFiltersInterface) => void;
  totalesMovimientosContables: TotalesMovimientosContables | null;
  setTotalesMovimientosContables: (data: TotalesMovimientosContables | null) => void;
  resumenEnviados: RespuestaRegistrosEnviados[] | null;
  setResumenEnviados: (data: RespuestaRegistrosEnviados[]) => void;
  getTotalesMovimientosContables: () => Promise<void>;
}

const ValidadorAsientosContablesContext = createContext<AsientosContablesContextType | undefined>(undefined);

export const useValidadorAsientosContablesContext = () => {
  const context = useContext(ValidadorAsientosContablesContext);
  if (!context) {
    throw new Error("useValidadorAsientosContablesContext debe usarse dentro de un ValidadorAsientosContablesProvider");
  }
  return context;
};

export const ValidadorAsientosContablesProvider = ({ children }: { children: React.ReactNode }) => {

  const location = useLocation();
  const {showLoader, hideLoader} = useLoader();
  const [reloadFlag, setReloadFlag] = useState<number>(0);
  const [formFilters, setFormFilters] = useState<FormFiltersInterface | null>(null);
  const [totalesMovimientosContables, setTotalesMovimientosContables] = useState<TotalesMovimientosContables | null>(null);
  const [resumenEnviados, setResumenEnviados] = useState<RespuestaRegistrosEnviados[] | null>(null);

  const getTotalesMovimientosContables = async () => {
    if (!formFilters) return;

    try {
      showLoader();
      const resultado = await obtenerTotalesMovimientosContables(formFilters);
      setTotalesMovimientosContables(resultado.data);
      hideLoader();
    } catch (error) {
      hideLoader();
      console.error("Error al obtener totales movimientos contables:", error);
    }
  };

  const incrementReloadFlag = () => setReloadFlag(reloadFlag + 1);

  useEffect( () => {
    if(reloadFlag > 0) getTotalesMovimientosContables();
  }, [reloadFlag] );


  useEffect(() => {
    if (location.state != null || location.state?.estado != null ){
      setFormFilters(location.state?.estado || location.state);
    }
  }, [location.state]);

  return (
    <ValidadorAsientosContablesContext.Provider value={{ 
      reloadFlag,
      incrementReloadFlag,
      formFilters, 
      setFormFilters, 
      totalesMovimientosContables, 
      setTotalesMovimientosContables,
      resumenEnviados,
      setResumenEnviados,
      getTotalesMovimientosContables
    }}>
      {children}
    </ValidadorAsientosContablesContext.Provider>
  );
};
